// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__cVXej","topBar":"Card_topBar__DZZ0V","title":"Card_title__RPcP8","cardBody":"Card_cardBody__lcuUR"};